import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home.js';
import Map from './pages/Map.js';
import Discover from './pages/Discover.js';
import Detail from './pages/Detail.js';
import Detail2 from './pages/Detail2.js';
import Service from './pages/Service.js';
import ServiceSub from './pages/ServiceSub.js';
import DiscoverSub from './pages/DiscoverSub.js';
import DiscoverSpecial from './pages/DiscoverSpecial.js';
import Article from './pages/Article.js';
import Error from './pages/Error.js';
import BottomTabs from './components/BottomTabs.js';
import TopTabs from './components/TopTabs.js';
import RequireActive from './components/RequireActive.js';
import VenueGate from './components/VenueGate';

const AppContent = () => {
    const location = useLocation();
    const isDetailOrErrorPage = location.pathname.startsWith("/service/detail") || location.pathname.startsWith("/discover/detail") || location.pathname === "/error";

    return (
        <div className="flex flex-col h-dvh font-fs-lola">
            <TopTabsWrapper />
            <main className={`flex-grow overflow-hidden overflow-y-auto mb-16 ${isDetailOrErrorPage ? "" : "mt-20"} main-scroll-container flex flex-col`}>
                <RequireActive>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/service" element={<Service />} />
                        <Route path="/service/list/:id" element={<ServiceSub />} />
                        <Route path="/service/detail/:id" element={<Detail />} />
                        <Route path="/article/:id" element={<Article />} />
                        <Route path="/discover/list/:id" element={<DiscoverSub />} />
                        <Route path="/discover/detail/:id" element={<Detail2 />} />
                        <Route path="/discover" element={<Discover />} />
                        <Route path="/map" element={<Map />} />
                        <Route path="/error" element={<Error />} />
                        <Route path="/discover-special" element={<DiscoverSpecial />} />
                    </Routes>
                </RequireActive>
            </main>
            <BottomTabsWrapper />
        </div>
    );
}

const App = () => {
    return (
        <Router>
            <VenueGate >
                <AppContent />
            </VenueGate>
        </Router>
    );
}

// 顶部导航栏
const TopTabsWrapper = () => {
    const location = useLocation();

    // Hide TopTabs on the Error or Detail pages
    if (location.pathname === '/error' || location.pathname.includes('/service/detail') || location.pathname.includes('/discover/detail')) {
        return null;
    }

    return <TopTabs />;
};

// 底部导航栏
const BottomTabsWrapper = () => {
    const location = useLocation();

    // Hide BottomTabs on the Error page
    if (location.pathname === '/error') {
        return null;
    }

    return <BottomTabs />;
};

//获取venue_id 用这个来拦住没有注入venueid的情况
export default App;
